import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ValidationErrorMessage from '../ValidationErrorMessage'
import PresenceValidator from '../../validators/PresenceValidator'
import IdNumberValidator from '../../validators/IdNumberValidator'
import EmailValidator from '../../validators/EmailValidator'

export default class Input extends Component {
  static propTypes = {
    name: PropTypes.string,
    wrapperClasses: PropTypes.string,
    inputType: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    isHalf: PropTypes.bool,
    validations: PropTypes.array,
    isRequired: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    maxLength: PropTypes.number,
    minLengthValidation: PropTypes.number,
    upperBound: PropTypes.number,
    hidden: PropTypes.bool,
    autoFocus: PropTypes.bool
  }

  static defaultProps = {
    validations: []
  }

  constructor (props) {
    super(props)
    this.state = {
      hasValue: !!props.value,
      errorMessage: ''
    }
  }

  componentDidMount = () => {
    this.fieldValidCallback(this.props.value)
  }

  fieldValidCallback = (value) => {
    if (this.props.isValidCallback && this.props.inputType != 'select') {
      const hasError = this.validateInput(value)

      if (hasError.replace(/\s/g, '') == '' || hasError == undefined) {
        this.props.isValidCallback(true)
      } else {
        this.props.isValidCallback(false)
      }
    }
  }

  wrapperClasses = () => {
    const wrapperClasses = this.props.wrapperClasses

    let defaultWrapper = `form-input form-input--large ${!this.props.hidden ? 'form-input--has-padding' : ''} has-floating-label` + this.isHalfClass() + this.hasErrorClass()

    if (wrapperClasses == undefined && this.props.inputType != 'select') {
      return defaultWrapper
    } else if (wrapperClasses == undefined && this.props.inputType == 'select') {
      return defaultWrapper + ' select'
    } else {
      return wrapperClasses
    }
  }

  isHalfClass = () => {
    if (this.props.isHalf) {
      return ' is-half'
    } else {
      return ''
    }
  }

  hasErrorClass = () => {
    if (this.state.errorMessage.replace(/\s/g, '') != '') {
      return ' has-error'
    } else {
      return ''
    }
  }

  renderRequiredAbbr () {
    if (this.props.isRequired) {
      return (
        <abbr title='required'>*</abbr>
      )
    }
  }

  validateInput = (value) => {
    if (this.props.validations.length > 0) {
      return this.props.validations.map((validator) => {
        switch (validator) {
          case 'presence':
            if (!PresenceValidator.isValid(value)) {
              return 'This field is required.'
            }
            break
          case 'email':
            if (!EmailValidator.isValid(value)) {
              return 'A valid email is required.'
            }
            return ''
            break
          case 'idnumber':
            return this.idNumberValidator(value)
            break
          case 'passport':
            if (value.length < 6 || value.length > 9) {
              return 'A valid passport number is required.'
            }
            break
          case 'numeric':
            if (!this.numericValidator(value)) {
              return 'A valid numeric value is required.'
            }
            break
          case 'year':
            if (!this.minLengthValidator(value) || !this.yearValidator(value)) {
              return 'A valid year is required.'
            }
            break
          case 'default':
            break
        }
      }).join(' ')
    }
    if (!this.minLengthValidator(value)) {
      return `A ${this.props.minLengthValidation} digit value is required.`
    }
    return ''
  }

  idNumberValidator (value) {
    if (value != undefined && value != '') {
      if (!IdNumberValidator.isValid(value)) {
        return 'The value entered is not a valid Id number'
      }
    } else {
      return 'This field is required'
    }
  }

  numericValidator (value) {
    if (!value || !isNaN(value) || !isNaN(value.split(' ').join(''))) {
      return true
    }
    return false
  }

  minLengthValidator (value) {
    if (this.props.minLengthValidation && value && value.length < this.props.minLengthValidation) {
      return false
    }
    return true
  }

  yearValidator (value) {
    let currentYear = new Date().getFullYear()
    if ((value && value < currentYear) ||
        (this.props.upperBound && value > this.props.upperBound)) {
      return false
    }
    return true
  }

  onChangeCallback = (event) => {
    const hasValue = event.target.value != ''
    const value = event.target.value
    const errorMessages = this.validateInput(value)

    this.setState({
      hasValue: hasValue,
      errorMessage: errorMessages
    }, function () {
      if (this.props.onChange) {
        this.props.onChange(value)
      }

      this.fieldValidCallback(value)
    })
  }

  onSelectChange = (event) => {
    const hasValue = event.target.value != ''
    const value = event.target.value

    this.setState({
      hasValue: hasValue
    }, function () {
      if (this.props.onChange) {
        this.props.onChange(value)
      }
    })
  }

  getMaxLengthFromProps = () => {
    if (isNaN(this.props.maxLength)) {
      return ''
    }
    return this.props.maxLength
  }

  render () {
    if (this.props.inputType == 'select') {
      return (
        <div key={this.props.id} className={this.wrapperClasses()}>
          <label className='form-control'>
            <div className='form-control__label'>
              <span>{this.props.label}</span> { this.renderRequiredAbbr() }
            </div>
            <div className='form-control__input'>
              <select className='select' defaultValue={this.props.value}
                name={this.props.name} id={this.props.id} onChange={(e) => this.onSelectChange(e)}>
                {this.props.children}
              </select>
              <span className='form-control__indicator' />
            </div>
          </label>
        </div>
      )
    } else {
      return (
        <div key={this.props.id} className={this.wrapperClasses()}>
          <label className='form-control'>
            { !this.props.hidden &&
            <div className='form-control__label'>
              <span>{this.props.label}</span>
              { this.renderRequiredAbbr() }
            </div>
            }
            <div className='form-control__input'>
              <input
                autoFocus={this.props.autoFocus}
                type={this.props.hidden ? `hidden` : `text`}
                onChange={(e) => this.onChangeCallback(e)}
                value={this.props.value}
                disabled={this.props.disabled}
                readOnly={this.props.readOnly}
                maxLength={this.getMaxLengthFromProps()}
                name={this.props.name}
                id={this.props.id} />
            </div>
          </label>
          <ValidationErrorMessage errorMessage={this.state.errorMessage} />
        </div>
      )
    }
  }
}
